module.exports = __webpack_public_path__ + "img/omanalytics.213a2b90.png";